import { useGenerateBoardingPassMutation, useRetrieveBoardingPassQuery } from 'services/boardingPasses';
import { BoardingPass } from 'ui/data-display/Passes/boardingPass';
import { BoardingPassInputs } from 'types';
import { createPassComponent } from 'components/reusable/pass';


export const AdminGenerateBoardingPass = createPassComponent<BoardingPassInputs>({
  isAdminView: true,
  TemplateRenderer: BoardingPass,
  baseSuccessUrl: '/backoffice/boarding-passes/',
  i18nNamespace: 'boardingPass',
  retrievePassTemplateHook: useRetrieveBoardingPassQuery,
  createPassHook: useGenerateBoardingPassMutation,
});

export const GenerateBoardingPass = createPassComponent<BoardingPassInputs>({
  isAdminView: false,
  TemplateRenderer: BoardingPass,
  successUrl: '/',
  i18nNamespace: 'boardingPass',
  retrievePassTemplateHook: useRetrieveBoardingPassQuery,
  createPassHook: useGenerateBoardingPassMutation,
});